export default __webpack_public_path__ + "static/media/grass.eb5fc8eb.jpg";